import jwtAxios from '@nxsys/services/axios';
import { endPoints } from '@nxsys/services/endpoints';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { GetDraftPayrollParams, GetDraftPayrollResponse } from '../type';

const getDraftPayrollList = createAsyncThunk(
  `/getDraftPayrollList`,
  async (
    params: GetDraftPayrollParams,
    { rejectWithValue },
  ): Promise<GetDraftPayrollResponse & { queryParams: GetDraftPayrollParams | null }> => {
    try {
      const response = await jwtAxios.get(`${endPoints.payroll.draft}`, {
        params,
      });
      return {
        data: response.data.data,
        totalDocs: response.data.totalDocs,
        success: response.data.success,
        pagination: {
          current: params.page || 0,
          pageSize: params.size || 20,
          totalDocs: response.data.totalDocs,
        },
        queryParams: params,
      };
    } catch (e) {
      throw rejectWithValue(e as Error);
    }
  },
);

export const payrollActs = {
  getDraftPayrollList,
};
